export default [
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/views/logs/pages/Log.vue'),
    meta: {
      resource: 'logs',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Logs',
      breadcrumb: [
        {
          text: 'Logs',
          active: true,
        },
      ],
    },
  },

]
